import { render } from "./BottomSection.vue?vue&type=template&id=6d524e40&scoped=true"
import script from "./BottomSection.vue?vue&type=script&lang=js"
export * from "./BottomSection.vue?vue&type=script&lang=js"

import "./BottomSection.vue?vue&type=style&index=0&id=6d524e40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d524e40"]])

export default __exports__